import gql from 'graphql-tag';
import { answerFieldsFragment } from './answerFieldsFragment';

export const questionStepFieldsFragment = gql`
  fragment AdminQuestionStepFields on QuestionStep {
    type
    answer { ...AdminAnswerFields }
    question
    score
  }

  ${answerFieldsFragment}
`;